import {
    addItemToCollection,
    deleteItemFromCollection,
} from "directus/src/operations";

export async function removeTestimonials(id) {
    try {
        const response = await deleteItemFromCollection("testimonials", id);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function createTestimonials({ item }) {
    try {
        const query = {
            fields: [
                "id",
                "feedback",
                "case_study.id",
            ],
        };
        const data = await addItemToCollection("testimonials", item, query);
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}